import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import AddTrustForm from '../../../../components/TrustForm';

import {
    fetchCountries,
    fetchStates
} from '../../../../../../services/redux/commonData/actions';

import {
    addNewTrust,
    updateAddNewTrustPayload,
    handleAddTrustVisibility
} from '../../../../../../services/redux/employee/trust/actions';
import { formInputValidation } from '../../../../../../services/helper/form-helper';

class AddTrust extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }

    onSubmitClick = () => {
        let { 
            trust, 
            addNewTrust, 
            handleAddTrustVisibility, 
            parentClient 
        } = this.props;
        let payload = {...trust.addNewTrust, clientId: parentClient.value};
        if (formInputValidation(this.formRef.current)) {
            addNewTrust(payload).then(response => {
                if (response.status === 200) {
                    handleAddTrustVisibility(false);
                }
            });
        }
    };

    onCancelClick = () => {
        let { handleAddTrustVisibility } = this.props;
        handleAddTrustVisibility(false);
    };

    render() {
        let { trust, commonData, updateAddNewTrustPayload } = this.props;
        let submitButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSubmitClick}
            >
                Submit
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [submitButton, cancelButton];

        return (
            <div role="tabpanel" className="panel col-md-6 mb">
                <Tabs defaultActiveKey={1} id="tabID">
                    <Tab eventKey={1} title="Add Trust">
                        <Panel showFooter footerComponents={buttonList}>
                            <div>
                                <AddTrustForm
                                    trustData={trust.addNewTrust}
                                    countryList={commonData.countries}
                                    stateList={commonData.states}
                                    updateTrustData={updateAddNewTrustPayload}
                                    formRef={this.formRef}
                                />
                            </div>
                        </Panel>
                    </Tab>
                </Tabs>
                {trust.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    trust: state.employee.trust,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            addNewTrust,
            fetchCountries,
            fetchStates,
            updateAddNewTrustPayload,
            handleAddTrustVisibility
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AddTrust));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/NewRequest/screens/AddTrust/index.js